import {
    formFieldsForMoldAcceptance
} from '../../components/CreateMoldOrder/formConfigs';
import fetchersRegistry from '../../components/Questionnaire/fetchersRegistry';
import { MoldOrderMainType, MoldOrderStatus, MoldOrderType } from '../../types/mold';
import { AppState } from '../appState';
import { statusLabelsByCompany } from '../orderLabels';
import { injectionMachineService } from '@/services/api';
import { ROUTES } from '@/constants/routes';

export default {
    appName: 'SK',
    featureToggles: {
        production: {
            enableRepairMoldOrder: true,
            enableMajorRepair: false,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: true,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: false,
            enableShotCountLogPage: false,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: false,
        },
        staging: {
            enableRepairMoldOrder: true,
            enableMajorRepair: false,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: true,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: false,
            enableShotCountLogPage: false,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: true,
        },
        dev: {
            enableRepairMoldOrder: true,
            enableMajorRepair: false,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: true,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: true,
            enableShotCountLogPage: false,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: true,
        }
    },
    mold: {
        statusLabelMapping: {
            active: 'พร้อมใช้งาน',
            in_servicing: 'กำลังเช็คระดับ',
            repairing: 'กำลังซ่อม',
            modifying: 'กำลัง Modify',
            eol: 'สิ้นสุดการใช้งาน',
            inactive: 'ไม่พร้อมใช้งาน',
            arriving: 'รอเข้าโรงงาน',
            attention_required: 'ต้องการการดูแล',
            released_to_external: 'ส่งออกแล้ว',
            pending_export: 'รอส่งออก',
        },
        formConfiguration: {
            part: [],
            general: [
                {
                    key: 'moldCode',
                    type: 'text',
                    label: 'Mold Code',
                    placeholder: 'ระบุ Mold Code',
                    required: true,
                    disabled: false,
                },
                {
                    key: 'moldName',
                    type: 'text',
                    label: 'Mold Name',
                    placeholder: 'ระบุ Mold Name',
                    required: true,
                    disabled: false,
                },
                {
                    key: 'moldNumber',
                    type: 'text',
                    label: 'แม่พิมพ์ลูกที่',
                    placeholder: 'ระบุแม่พิมพ์ลูกที่',
                    required: true,
                },
                {
                    key: 'customerId',
                    type: 'search_dropdown',
                    label: 'รหัสลูกค้า',
                    placeholder: 'เลือกชื่อลูกค้า',
                    options: [],
                    fetch: fetchersRegistry['customer.getOptions'],
                    required: true,
                    enforceDropdownSelection: true,
                    validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                    allowInvalidInput: false
                },
                {
                    type: 'select',
                    key: 'moldSource',
                    options: [],
                    fetch: fetchersRegistry['mold.generic.moldSourceList'],
                    placeholder: 'เลือก Mold Source',
                    label: 'Mold Source',
                    required: true,
                },
                {
                    type: 'select',
                    key: 'moldType',
                    options: [],
                    fetch: fetchersRegistry['moldType'],
                    placeholder: 'เลือกประเภทแม่พิมพ์',
                    label: 'ประเภทของแม่พิมพ์',
                    required: true,
                },
                {
                    type: 'text',
                    key: 'makerName',
                    label: 'Mold Maker Name',
                    placeholder: 'ระบุชื่อผู้ผลิตแม่พิมพ์',
                    required: true,
                },
                {
                    type: 'text',
                    key: 'cavity',
                    label: 'Cavity',
                    required: true,
                    placeholder: 'ระบุจำนวน Cavity',
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'machineSizeMin',
                    label: 'MC Size Min',
                    options: [],
                    fetch: fetchersRegistry['mold.mcSizeList'],
                    required: true,
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'machineSizeMax',
                    label: 'MC Size Max',
                    options: [],
                    fetch: fetchersRegistry['mold.mcSizeList'],
                    required: true,
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'plate',
                    label: 'Plate',
                    options: [],
                    fetch: fetchersRegistry['plateType'],
                    placeholder: 'เลือก Plate Type',
                    required: false,
                },
                {
                    type: 'search_dropdown',
                    key: 'partMatGrade',
                    label: "Part Material Grade",
                    placeholder: 'ระบุเกรดวัสดุของชิ้นส่วน',
                    options: [],
                    fetch: fetchersRegistry['mold.partMatGradeList'],
                    enforceDropdownSelection: true,
                    required: false,
                    allowCreateNewOption: true,
                    createOptionConfig: {
                        entityType: 'mold.partMatGradeList',
                        onCreateSuccess: (newOption) => {
                            console.debug('Successfully created new part material grade:', newOption);
                        }
                    }
                },
                {
                    type: 'number',
                    key: 'maxShotCount',
                    label: 'Mold การันตี',
                    placeholder: 'ระบุจำนวนแม่พิมพ์การันตี',
                    required: true,
                },
                {
                    type: 'select',
                    key: 'surfaceFinish',
                    label: 'Surface Finish',
                    options: [],
                    fetch: fetchersRegistry['mold.surfaceFinish'],
                    placeholder: 'เลือก Surface Finish',
                    required: true,
                },
                {
                    type: 'text',
                    key: 'extraAttributes.textureNumber',
                    label: 'Texture Number',
                    placeholder: 'ระบุ Texture Number',
                    required: false,
                    showIf: (formData) => formData.surfaceFinish === 'Texture',
                }
            ],
            insert: [
                {
                    type: 'toggle',
                    key: 'insertEngraving',
                    label: 'Insert /Engraving',
                    required: false,
                },
                {
                    key: 'insertChangeType',
                    label: 'ลักษณะการเปลี่ยน Insert',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['mold.insertChangeType'],
                    required: false,
                },
            ],
        },
        displayFieldGroups: [
            {
                key: 'general',
                label: 'ข้อมูลทั่วไป',
                fields: [
                    {
                        key: 'moldCode',
                        type: 'text',
                        label: 'รหัสแม่พิมพ์',
                        required: true,
                        disabled: false,
                    },
                    {
                        key: 'moldName',
                        type: 'text',
                        label: 'Mold Name',
                        required: true,
                        disabled: false,
                    },
                    {
                        key: 'moldNumber',
                        type: 'text',
                        label: 'แม่พิมพ์ลูกที่',
                        required: true,
                    },
                    {
                        key: 'customerId',
                        type: 'search_dropdown',
                        label: 'รหัสลูกค้า',
                        placeholder: 'เลือกชื่อลูกค้า',
                        options: [],
                        fetch: fetchersRegistry['customer.getOptions'],
                        required: true,
                        enforceDropdownSelection: true,
                        validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                        allowInvalidInput: false
                    },
                    {
                        type: 'text',
                        key: 'revision',
                        label: 'Revision',
                        required: true,
                        disabled: true,
                    },
                    {
                        type: 'select',
                        key: 'moldType',
                        options: [],
                        fetch: fetchersRegistry['moldType'],
                        placeholder: 'เลือกประเภทแม่พิมพ์',
                        label: 'ประเภทของแม่พิมพ์',
                        required: true,
                    },
                    {
                        type: 'select',
                        key: 'moldSource',
                        options: [],
                        fetch: fetchersRegistry['mold.moldSourceList'],
                        placeholder: 'เลือก Mold Source',
                        label: 'Mold Source',
                        required: true,
                    },
                    {
                        type: 'text',
                        key: 'cavity',
                        label: 'Cavity',
                        required: false,
                    },
                    {
                        type: 'text',
                        key: 'makerName',
                        label: 'Mold Maker Name',
                        placeholder: 'ระบุชื่อผู้ผลิตแม่พิมพ์',
                        required: true,
                    },
                    {
                        type: 'select',
                        key: 'plate',
                        label: 'Plate',
                        options: [],
                        fetch: fetchersRegistry['plateType'],
                        placeholder: 'เลือก Plate Type',
                        required: false,
                    },
                    {
                        type: 'select',
                        key: 'gateType',
                        options: [],
                        fetch: fetchersRegistry['gateType'],
                        placeholder: 'เลือก Gate Type',
                        label: 'Gate Type',
                        required: true,
                    },
                    {
                        type: 'toggle',
                        key: 'delayGate',
                        label: 'Delay Gate',
                        required: false,
                    },
                    {
                        type: 'toggle',
                        key: 'hotRunner',
                        label: 'Hot Runner',
                        required: false,
                    },
                    {
                        key: 'hotRunnerType',
                        label: 'Hot Runner Type',
                        options: [],
                        fetch: fetchersRegistry['mold.hotRunnerTypeList'],
                        required: false,
                        type: 'select_with_other_and_custom',
                    },
                    {
                        key: 'hotRunnerBrand',
                        label: 'Hot Runner Brand',
                        required: false,
                        type: 'text',
                    },
                    {
                        key: 'qtyZoneHr',
                        label: "Q'ty Zone HR",
                        required: false,
                        type: 'text',
                    },
                    {
                        key: 'partMatGrade',
                        label: "Part Material Grade",
                        placeholder: 'ระบุเกรดวัสดุของชิ้นส่วน',
                        required: true,
                        type: 'search_dropdown',
                        options: [],
                        fetch: fetchersRegistry['mold.partMatGradeList'],
                        enforceDropdownSelection: true,
                        allowCreateNewOption: true,
                        createOptionConfig: {
                            entityType: 'mold.partMatGradeList',
                        }
                    },
                    {
                        type: 'select',
                        key: 'surfaceFinish',
                        label: 'Surface Finish',
                        options: [],
                        fetch: fetchersRegistry['mold.surfaceFinish'],
                        placeholder: 'เลือก Surface Finish',
                        required: true,
                    },
                    {
                        type: 'text',
                        key: 'extraAttributes.textureNumber',
                        label: 'Texture Number',
                        placeholder: 'ระบุ Texture Number',
                        required: false,
                        showIf: (formData: any) => formData.surfaceFinish === 'Texture',
                    },
                    {
                        key: 'remarks',
                        label: 'จุดที่ต้องระวัง',
                        required: false,
                        type: 'textarea',
                    },
                ],
                uiConfig: {
                    icon: 'Info',
                    showShotCountBar: true,
                }
            },
            {
                key: 'shotCount',
                label: 'จำนวนชอต',
                fields: [
                    {
                        key: 'cycleShotCount',
                        label: 'ชอตสะสมจากระบบในรอบล้าง',
                        required: false,
                        type: 'number',
                        disabled: true,
                    },
                    {
                        key: 'shotCount',
                        label: 'ชอตสะสมจากระบบ',
                        required: false,
                        type: 'number',
                    },
                    {
                        key: 'physicalShotCount',
                        label: 'ชอตสะสมของเคาน์เตอร์แม่พิมพ์',
                        required: false,
                        type: 'number',
                    },
                    {
                        type: 'number',
                        key: 'servicingAlertShotThreshold',
                        label: 'ชอตเตือนเซอร์วิส',
                        required: true,
                    },
                    {
                        type: 'number',
                        key: 'servicingMaxShotThreshold',
                        label: 'ชอตที่ต้องเซอร์วิส',
                        required: true,
                    },
                    {
                        type: 'number',
                        key: 'maxShotCount',
                        label: 'Mold การันตี',
                        required: true,
                    },
                ],
                uiConfig: {
                    icon: 'FileDigitIcon',
                    showShotCountBar: true,
                }
            },
            {
                key: 'dimensions',
                label: 'ขนาด',
                fields: [
                    {
                        type: 'number',
                        key: 'width',
                        label: 'ความกว้าง (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'length',
                        label: 'ความสูง (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'height',
                        label: 'ความหนา (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'weight',
                        label: 'น้ำหนัก (kg)',
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'machineSizeMin',
                        label: 'MC Size Min',
                        options: [],
                        fetch: fetchersRegistry['mold.mcSizeList'],
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'machineSizeMax',
                        label: 'MC Size Max',
                        options: [],
                        fetch: fetchersRegistry['mold.mcSizeList'],
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'extraAttributes.wLeft',
                        label: 'เยื้องศูนย์ซ้าย (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'extraAttributes.wRight',
                        label: 'เยื้องศูนย์ขวา (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'extraAttributes.hUpper',
                        label: 'เยื้องศูนย์บน (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'extraAttributes.hLower',
                        label: 'เยื้องศูนย์ล่าง (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'extraAttributes.openDaylight',
                        label: 'ระยะเปิดโมลด์ (mm)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'locatedRingOd',
                        label: 'Located Ring O.D. (ขนาด OD)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'nozzleSr',
                        label: 'Nozzle SR (R ของ Nozzle)',
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'Box',
                    showShotCountBar: false,
                }
            },
            {
                key: 'insert',
                label: 'Insert',
                fields: [
                    {
                        type: 'toggle',
                        key: 'insertEngraving',
                        label: 'Insert /Engraving',
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'insertChangeType',
                        label: 'ลักษณะการเปลี่ยน Insert',
                        options: [],
                        fetch: fetchersRegistry['mold.insertChangeType'],
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'PocketKnife',
                    showShotCountBar: false,
                }
            },
            {
                key: 'location',
                label: 'ที่ตั้ง',
                fields: [
                    {
                        type: 'text',
                        key: 'currentLocation',
                        label: 'ที่อยู่แม่พิมพ์',
                        required: false,
                    },
                    {
                        type: 'text',
                        key: 'storageLocation',
                        label: 'ที่เก็บ',
                        required: false,
                    },
                    {
                        type: 'text',
                        key: 'assetNoCustomer',
                        label: 'Asset NO Customer',
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'MapPin',
                    showShotCountBar: false,
                }
            },
        ],
        displayFields: {
            primaryField: 'moldCode',
            secondaryField: 'moldName'
        }
    },
    moldOrderDetail: {
        header: {
            title: 'moldCode',
            subtitle: 'moldName',
        }
    },
    moldOrders: {
        maintenance: {
            title: 'เช็คระดับ',
            orderTemplateVersion: '1.1',
            isEnable: true,
            creationConfig: {
                allowedStatuses: ['active'],
            },
            formConfigs: [
                {
                    key: 'moldOrderType',
                    label: 'ประเภทการตรวจเช็คแม่พิมพ์',
                    type: 'select',
                    options: [
                        {
                            value: MoldOrderType.MAINTENANCE_LEVEL1,
                            label: 'ตรวจเช็คระดับ 1'
                        },
                        {
                            value: MoldOrderType.MAINTENANCE_LEVEL2,
                            label: 'ตรวจเช็คระดับ 2'
                        }
                    ],
                    required: true,
                },
                {
                    key: 'dueDate',
                    label: 'กำหนดเสร็จ',
                    type: 'date',
                    required: true,
                    defaultDateOffset: 14,
                },
                {
                    key: 'note',
                    label: 'คำสั่งเพิ่มเติม',
                    type: 'select',
                    options: [],
                    fetch: fetchersRegistry['moldOrder.notes'],
                    required: true,
                    defaultValue: 'ไม่มี',
                },
                {
                    key: 'customNote',
                    label: 'ระบุคำขอให้ดำเนินการเพิ่มเติม',
                    type: 'text',
                    placeholder: 'ระบุข้อความพิมพ์',
                    showIf: (details: any) => details.note === 'other_custom_text',
                    required: true,
                },
                {
                    key: 'priority',
                    label: 'ระดับความสำคัญ',
                    type: 'select',
                    options: [
                        {
                            value: 200,
                            label: 'ปกติ'
                        },
                        {
                            value: 100,
                            label: 'เร่งด่วน'
                        },
                        {
                            value: 1,
                            label: 'เร่งด่วนมาก'
                        }
                    ],
                    defaultValue: 200,
                    required: true,
                },
            ],
            checkForFormCompletion: false,
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.MAINTENANCE_LEVEL1,
                    label: 'ตรวจเช็คระดับ 1',
                    subTypes: [
                        MoldOrderType.MAINTENANCE_LEVEL1,
                    ]
                },
                {
                    value: MoldOrderMainType.MAINTENANCE_LEVEL2,
                    label: 'ตรวจเช็คระดับ 2',
                    subTypes: [
                        MoldOrderType.MAINTENANCE_LEVEL2,
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.MAINTENANCE_LEVEL1,
                MoldOrderType.MAINTENANCE_LEVEL2
            ],
            statusMapping: statusLabelsByCompany.sk.maintenance,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PICK_UP,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.PICK_UP]: 'amber',
                    [MoldOrderStatus.IN_PROGRESS]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_ACKNOWLEDGE]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'PrioritizeMoldOrder',
                    ],
                },
                [MoldOrderStatus.PICK_UP]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เริ่มเช็คระดับ',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.PICK_UP]: 'Clock',
                    [MoldOrderStatus.IN_PROGRESS]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                }
            },
            uiConfig: {
                icon: {
                    name: 'ShieldHalf',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-blue-500 to-indigo-600',
                    textColor: 'text-white',
                    borderColor: 'border-blue-200',
                    shadow: 'shadow-lg shadow-blue-200/50',
                },
                colorCode: 'blue',
            }
        },
        modify: {
            title: 'Modify',
            orderTemplateVersion: '1.1',
            creationConfig: {
                allowedStatuses: ['active'],
                featureToggle: 'enabledModifyOrder',
                customDisabledMessage: 'ฟีเจอร์ยังไม่เปิดใช้งาน',
            },
            formConfigs: [
                {
                    key: 'moldOrderType',
                    label: 'ประเภทการดำเนินการ',
                    type: 'select',
                    options: [
                        {
                            value: MoldOrderType.MODIFY,
                            label: 'Modify แม่พิมพ์',
                            cardStyle: 'bg-amber-100 text-amber-800'
                        }
                    ],
                    defaultValue: MoldOrderType.MODIFY,
                    required: true,
                },
                {
                    key: 'modifyCause',
                    label: 'สาเหตุที่ต้องการ Modify',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['repairModifyCausesList'],
                    required: true,
                },
                {
                    key: 'machineToProduce',
                    type: 'search_dropdown',
                    label: 'เครื่องที่ทำการผลิต (ถ้ามี)',
                    placeholder: 'ระบุเครื่องที่ทำการผลิต',
                    options: [],
                    fetch: injectionMachineService.getOptions,
                    required: false,
                    enforceDropdownSelection: true,
                    validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                    allowInvalidInput: false,
                },
                {
                    key: 'reporterName',
                    label: 'ชื่อผู้แจ้งปัญหา (ถ้ามี)',
                    type: 'text',
                    placeholder: 'ระบุชื่อผู้แจ้งปัญหา',
                    required: false,
                },
                {
                    key: 'modifyRequirementNote',
                    label: 'รายละเอียดที่ต้องการให้ดำเนินการ',
                    type: 'textarea',
                    placeholder: 'ระบุรายละเอียดที่ต้องการให้ดำเนินการ',
                    required: true,
                },
                {
                    key: 'priority',
                    label: 'ระดับความสำคัญ',
                    type: 'select',
                    options: [
                        {
                            value: 200,
                            label: 'ปกติ'
                        },
                        {
                            value: 100,
                            label: 'เร่งด่วน'
                        },
                        {
                            value: 1,
                            label: 'เร่งด่วนมาก'
                        }
                    ],
                    defaultValue: 200,
                    required: true,
                },
                {
                    key: 'dueDate',
                    label: 'กำหนดเสร็จ',
                    type: 'date',
                    required: false,
                    defaultDateOffset: 14,
                },
            ],
            isEnable: 'enableRepairMoldOrder',
            checkForFormCompletion: false,
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.MODIFY,
                    label: 'Modify แม่พิมพ์',
                    subTypes: [
                        MoldOrderType.MODIFY,
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.MODIFY,
            ],
            statusMapping: statusLabelsByCompany.sk.modify,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_REPAIR,
                ]
            },
            statusDueDateBehavior: {
                all: {
                    // Waiting on the customer to inspect/accept — pause the SK due-date
                    // warning and instead count days, escalating to amber after 10 days.
                    [MoldOrderStatus.CUSTOMER_REVIEW]: {
                        suppressDueDateWarning: true,
                        responseReminder: { warnAfterDays: 10, label: 'รอลูกค้า {days} วัน' },
                    },
                },
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.ASSESSMENT]: 'amber',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'gray',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'gray',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'gray',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_REPAIR]: 'yellow',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'yellow',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.PENDING_TESTING]: 'yellow',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'gray',
                    [MoldOrderStatus.CUSTOMER_REVIEW]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.REPORTER_FILL_FORM]: {
                    buttonType: 'submit',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.MODIFICATION_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_ACKNOWLEDGE]: {
                    buttonType: 'submit',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.ASSESSMENT]: {
                    buttonType: 'submit',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.MARKETING_APPROVAL]: {
                    buttonType: 'submit',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PLANNING_APPROVAL]: {
                    buttonType: 'submit',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: {
                    buttonType: 'submit',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_REPAIR]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เริ่ม Modify',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPAIR_IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_TESTING]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ยืนยันแผนทดสอบ',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPORTER_REVIEW]: {
                    buttonType: 'submit',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PENDING_TESTING]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.CUSTOMER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                }
            },
            uiConfig: {
                icon: {
                    name: 'Wrench',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                    textColor: 'text-white',
                    borderColor: 'border-amber-200',
                    shadow: 'shadow-lg shadow-amber-200/50',
                },
                colorCode: 'yellow',
            },
        },
        repair: {
            title: 'ซ่อม',
            orderTemplateVersion: '1.1',
            creationConfig: {
                allowedStatuses: ['active'],
                featureToggle: 'enableRepairMoldOrder',
                customDisabledMessage: 'ฟีเจอร์ยังไม่เปิดใช้งาน',
            },
            formConfigs: [
                {
                    key: 'moldOrderType',
                    label: 'ประเภทการดำเนินการ',
                    type: 'select',
                    options: [
                        {
                            value: MoldOrderType.REPAIR,
                            label: 'ซ่อมแม่พิมพ์',
                            cardStyle: 'bg-blue-100 text-blue-800'
                        },
                    ],
                    defaultValue: MoldOrderType.REPAIR,
                    required: true,
                },
                {
                    key: 'rootCause',
                    label: 'สาเหตุที่จะซ่อม',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['repairRootCausesList'],
                    required: true,
                },
                {
                    key: 'machineToProduce',
                    type: 'search_dropdown',
                    label: 'เครื่องที่ทำการผลิต (ถ้ามี)',
                    placeholder: 'ระบุเครื่องที่ทำการผลิต',
                    options: [],
                    fetch: injectionMachineService.getOptions,
                    required: false,
                    enforceDropdownSelection: true,
                    validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                    allowInvalidInput: false,
                },
                {
                    key: 'reporterName',
                    label: 'ชื่อผู้แจ้งปัญหา (ถ้ามี)',
                    type: 'text',
                    placeholder: 'ระบุชื่อผู้แจ้งปัญหา',
                    required: false,
                },
                {
                    key: 'modifyRequirementNote',
                    label: 'รายละเอียดที่ต้องการให้ดำเนินการ',
                    type: 'textarea',
                    placeholder: 'ระบุรายละเอียดที่ต้องการให้ดำเนินการ',
                    required: true,
                },
                {
                    key: 'priority',
                    label: 'ระดับความสำคัญ',
                    type: 'select',
                    options: [
                        {
                            value: 200,
                            label: 'ปกติ'
                        },
                        {
                            value: 100,
                            label: 'เร่งด่วน'
                        },
                        {
                            value: 1,
                            label: 'เร่งด่วนมาก'
                        }
                    ],
                    defaultValue: 200,
                    required: true,
                },
                {
                    key: 'dueDate',
                    label: 'กำหนดเสร็จ',
                    type: 'date',
                    required: false,
                    defaultDateOffset: 14,
                },
            ],
            isEnable: 'enableRepairMoldOrder',
            checkForFormCompletion: false,
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.REPAIR,
                    label: 'ซ่อมแม่พิมพ์',
                    subTypes: [
                        MoldOrderType.REPAIR,
                    ]
                },
                {
                    value: MoldOrderMainType.MODIFY,
                    label: 'Modify แม่พิมพ์',
                    subTypes: [
                        MoldOrderType.MODIFY,
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.REPAIR,
            ],
            statusMapping: statusLabelsByCompany.sk.repair,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_REPAIR,
                ]
            },
            statusDueDateBehavior: {
                all: {
                    // Waiting on the customer to inspect/accept — pause the SK due-date
                    // warning and instead count days, escalating to amber after 10 days.
                    [MoldOrderStatus.CUSTOMER_REVIEW]: {
                        suppressDueDateWarning: true,
                        responseReminder: { warnAfterDays: 10, label: 'รอลูกค้า {days} วัน' },
                    },
                },
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.ASSESSMENT]: 'amber',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'gray',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'gray',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'gray',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_REPAIR]: 'yellow',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'yellow',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.PENDING_TESTING]: 'yellow',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'gray',
                    [MoldOrderStatus.CUSTOMER_REVIEW]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.REPORTER_FILL_FORM]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_ACKNOWLEDGE]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'PrioritizeMoldOrder',
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.ASSESSMENT]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.MARKETING_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.MODIFICATION_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PLANNING_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_REPAIR]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ซ่อมแม่พิมพ์',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPAIR_IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_TESTING]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เสร็จสิ้นการทดสอบ',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPORTER_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PENDING_TESTING]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.CUSTOMER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                }
            },
            uiConfig: {
                icon: {
                    name: 'Wrench',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                    textColor: 'text-white',
                    borderColor: 'border-amber-200',
                    shadow: 'shadow-lg shadow-amber-200/50',
                },
                colorCode: 'yellow',
            },
        },
        repairModify: {
            title: 'ซ่อม/Modify',
            orderTemplateVersion: '1.1',
            formConfigs: [
                {
                    key: 'moldOrderType',
                    label: 'ประเภทการดำเนินการ',
                    type: 'select',
                    options: [
                        {
                            value: MoldOrderType.REPAIR,
                            label: 'ซ่อมแม่พิมพ์',
                            cardStyle: 'bg-blue-100 text-blue-800'
                        },
                        {
                            value: MoldOrderType.MODIFY,
                            label: 'Modify แม่พิมพ์',
                            cardStyle: 'bg-amber-100 text-amber-800'
                        }
                    ],
                    required: true,
                },
                {
                    key: 'rootCause',
                    label: 'สาเหตุที่จะซ่อม',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['repairRootCausesList'],
                    required: true,
                    showIf: (details: any) => details.moldOrderType === MoldOrderType.REPAIR,
                },
                {
                    key: 'modifyCause',
                    label: 'สาเหตุที่ต้องการ Modify',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['repairModifyCausesList'],
                    required: true,
                    showIf: (details: any) => details.moldOrderType === MoldOrderType.MODIFY,
                },
                {
                    key: 'machineToProduce',
                    type: 'search_dropdown',
                    label: 'เครื่องที่ทำการผลิต (ถ้ามี)',
                    placeholder: 'ระบุเครื่องที่ทำการผลิต',
                    options: [],
                    fetch: injectionMachineService.getOptions,
                    required: false,
                    enforceDropdownSelection: true,
                    validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                    allowInvalidInput: false,
                },
                {
                    key: 'reporterName',
                    label: 'ชื่อผู้แจ้งปัญหา (ถ้ามี)',
                    type: 'text',
                    placeholder: 'ระบุชื่อผู้แจ้งปัญหา',
                    required: false,
                },
                {
                    key: 'modifyRequirementNote',
                    label: 'รายละเอียดที่ต้องการให้ดำเนินการ',
                    type: 'textarea',
                    placeholder: 'ระบุรายละเอียดที่ต้องการให้ดำเนินการ',
                    required: true,
                },
                {
                    key: 'priority',
                    label: 'ระดับความสำคัญ',
                    type: 'select',
                    options: [
                        {
                            value: 200,
                            label: 'ปกติ'
                        },
                        {
                            value: 100,
                            label: 'เร่งด่วน'
                        },
                        {
                            value: 1,
                            label: 'เร่งด่วนมาก'
                        }
                    ],
                    defaultValue: 200,
                    required: true,
                },
                {
                    key: 'dueDate',
                    label: 'กำหนดเสร็จ',
                    type: 'date',
                    required: false,
                    defaultDateOffset: 14,
                },
            ],
            isEnable: 'enableRepairMoldOrder',
            checkForFormCompletion: false,
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.REPAIR,
                    label: 'ซ่อมแม่พิมพ์',
                    subTypes: [
                        MoldOrderType.REPAIR,
                    ]
                },
                {
                    value: MoldOrderMainType.MODIFY,
                    label: 'Modify แม่พิมพ์',
                    subTypes: [
                        MoldOrderType.MODIFY,
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.REPAIR,
                MoldOrderType.MODIFY,
            ],
            statusMapping: statusLabelsByCompany.sk.repairModify,
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PENDING_TESTING]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.CUSTOMER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                }
            },
            uiConfig: {
                icon: {
                    name: 'Wrench',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                    textColor: 'text-white',
                    borderColor: 'border-amber-200',
                    shadow: 'shadow-lg shadow-amber-200/50',
                },
                colorCode: 'yellow',
            },
        },
        mold_acceptance: {
            title: 'รับแม่พิมพ์',
            orderTemplateVersion: '1.1',
            isEnable: 'enableMoldAcceptanceCreation',
            formConfigs: formFieldsForMoldAcceptance,
            checkForFormCompletion: true,
            creationConfig: {
                allowedStatuses: ['inactive', 'released_to_external'],
                featureToggle: 'enableMoldAcceptanceCreation',
            },
            moldOrderMainTypes: [],
            moldOrderTypes: [
                MoldOrderType.MOLD_ACCEPTANCE
            ],
            statusMapping: statusLabelsByCompany.sk.mold_acceptance,
            disallowSetNextAssignee: {
                all: []
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_ARRIVAL]: 'blue',
                    [MoldOrderStatus.INITIAL_INSPECTION]: 'yellow',
                    [MoldOrderStatus.CLEANING_BEFORE_TESTING]: 'yellow',
                    [MoldOrderStatus.PENDING_TESTING]: 'yellow',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.APPROVAL]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_ARRIVAL]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับแม่พิมพ์',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [],
                },
                [MoldOrderStatus.DETAILED_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                        'PrintQRCode',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ],
                },
                [MoldOrderStatus.APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.MARKETING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.MODIFICATION_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PLANNING_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PENDING_TESTING]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                }
            },
            uiConfig: {
                icon: {
                    name: 'OutlinedMoldIcon',
                    source: 'custom',
                    props: { color: "#2563eb", size: 24, strokeWidth: 60, showHolders: false, activeColor: "#ffffff" },
                    disabledProps: { color: "#9CA3AF", size: 24, strokeWidth: 60, showHolders: false },
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                    textColor: 'text-white',
                    borderColor: 'border-emerald-200',
                    shadow: 'shadow-lg shadow-emerald-200/50',
                },
                colorCode: 'green',
            }
        },
        mold_export: {
            title: 'ส่งออกแม่พิมพ์',
            orderTemplateVersion: '1.0',
            formConfigs: [
                {
                    key: 'expectedExportDate',
                    label: 'กำหนดการส่งคืน (คาดการณ์)',
                    type: 'date',
                    required: true,
                },
                {
                    key: 'rootCause',
                    label: 'สาเหตุที่ส่งออก',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['mold.exportRootCausesList'],
                    required: true,
                },
            ],
            checkForFormCompletion: false,
            creationConfig: {
                allowedStatuses: ['active'],
            },
            moldOrderMainTypes: [],
            moldOrderTypes: [
                MoldOrderType.MOLD_EXPORT
            ],
            isEnable: true,
            statusMapping: statusLabelsByCompany.sk.mold_export,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_INSPECTION,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_INSPECTION]: 'yellow',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.GM_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_EXPORT]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เริ่มตรวจสอบ',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.DETAILED_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.GM_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.PENDING_EXPORT]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งออกแม่พิมพ์',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_INSPECTION]: 'FileText',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.GM_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_EXPORT]: 'Truck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            uiConfig: {
                icon: {
                    name: 'Truck',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                    textColor: 'text-white',
                    borderColor: 'border-emerald-200',
                    shadow: 'shadow-lg shadow-emerald-200/50',
                },
                colorCode: 'gray',
            }
        }
    },
    moldOrderCreation: {
        moldTable: {
            visibleColumns: [
                { key: 'moldCode', label: 'Mold Code', sortable: true, filterable: true },
                { key: 'moldName', label: 'Mold Name', sortable: true, filterable: true },
                { key: 'customer', label: 'ลูกค้า', sortable: true, filterable: true },
                { key: 'status', label: 'สถานะ', sortable: true, filterable: true },
                { key: 'shotCount', label: '#Shot', sortable: false, filterable: false },
            ]
        },
        orderTypes: [
            'mold_acceptance',
            'maintenance',
            'repair',
            'modify',
            'mold_export'
        ],
    },
    kanban: {
        card: {
            title: 'moldCode',
            subtitle: 'moldName',
        },
        boards: {
            data: [
                {
                    key: 'maintenance',
                    group: 'maintenance',
                    moldOrderTypes: [
                        MoldOrderMainType.MAINTENANCE_LEVEL1,
                        MoldOrderMainType.MAINTENANCE_LEVEL2,
                    ],
                    filters: {
                        moldOrderTypeGroups: [
                            {
                                value: MoldOrderMainType.MAINTENANCE_LEVEL1,
                                label: 'ตรวจเช็คระดับ 1',
                                subTypes: [
                                    MoldOrderType.MAINTENANCE_LEVEL1,
                                ]
                            },
                            {
                                value: MoldOrderMainType.MAINTENANCE_LEVEL2,
                                label: 'ตรวจเช็คระดับ 2',
                                subTypes: [
                                    MoldOrderType.MAINTENANCE_LEVEL2,
                                ]
                            }
                        ],
                    },
                    title: 'เช็คระดับ',
                    columns: [
                        {
                            id: 'pending-acknowledge',
                            title: 'รอรับใบงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ACKNOWLEDGE
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'pick-up',
                            title: 'รอเช็คระดับ',
                            statusIds: [
                                MoldOrderStatus.PICK_UP
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-200/50',
                            icon: 'Clock',
                        },
                        {
                            id: 'in-progress',
                            title: 'กำลังตรวจเช็ค',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'รอหัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'ShieldHalf',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-blue-500 to-indigo-600',
                            textColor: 'text-white',
                            borderColor: 'border-blue-200',
                            shadow: 'shadow-lg shadow-blue-200/50',
                        },
                        colorCode: 'blue',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MAINTENANCE_ORDERS
                },
                {
                    key: 'repair',
                    group: 'repair',
                    moldOrderTypes: [
                        MoldOrderType.REPAIR,
                    ],
                    filters: {
                        moldOrderTypeGroups: [],
                    },
                    version: 2,
                    title: 'ซ่อม',
                    relatedBoardKey: 'repair-v1',
                    columns: [
                        {
                            id: 'reporter-fill-form',
                            title: 'กรอกข้อมูลปัญหา',
                            statusIds: [
                                MoldOrderStatus.REPORTER_FILL_FORM
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-300 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-200',
                            countBg: 'bg-gray-50',
                            icon: 'SquarePenIcon',
                        },
                        {
                            id: 'pending-acknowledge',
                            title: 'รอรับใบงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ACKNOWLEDGE
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'assessment',
                            title: 'ประเมินเบื้องต้น',
                            statusIds: [
                                MoldOrderStatus.ASSESSMENT
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'HardHatIcon',
                        },
                        {
                            id: 'sk-repair-plan-approval',
                            title: 'อนุมัติแผนซ่อม',
                            statusIds: [
                                MoldOrderStatus.MARKETING_APPROVAL,
                                MoldOrderStatus.PLANNING_APPROVAL,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pending-repair',
                            title: 'รอซ่อม',
                            statusIds: [
                                MoldOrderStatus.PENDING_REPAIR
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'repair-in-progress',
                            title: 'กำลังซ่อม',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS,
                                MoldOrderStatus.REPAIR_IN_PROGRESS,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-200 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-300',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างตรวจงาน',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pending-testing',
                            title: 'ออกใบทดลองพิมพ์',
                            statusIds: [
                                MoldOrderStatus.PENDING_TESTING
                            ],
                            colorCode: 'fuchsia',
                            color: 'bg-fuchsia-100 text-fuchsia-800',
                            textColor: 'text-fuchsia-800',
                            hoverColor: 'hover:bg-fuchsia-200',
                            countBg: 'bg-fuchsia-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'reporter-review',
                            title: 'SK ตรวจงาน',
                            statusIds: [
                                MoldOrderStatus.REPORTER_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Wrench',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                            textColor: 'text-white',
                            borderColor: 'border-amber-200',
                            shadow: 'shadow-lg shadow-amber-200/50',
                        },
                        colorCode: 'yellow',
                    },
                    createNewOrderUrl: ROUTES.CREATE_REPAIR_ORDERS
                },
                {
                    key: 'modify',
                    group: 'modify',
                    moldOrderTypes: [
                        MoldOrderType.MODIFY
                    ],
                    filters: {
                        moldOrderTypeGroups: [

                        ],
                    },
                    version: 2,
                    title: 'Modify',
                    relatedBoardKey: 'repair-v1',
                    columns: [
                        {
                            id: 'reporter-fill-form',
                            title: 'กรอกข้อมูลปัญหา',
                            statusIds: [
                                MoldOrderStatus.REPORTER_FILL_FORM
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-300 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-200',
                            countBg: 'bg-gray-50',
                            icon: 'SquarePenIcon',
                        },
                        {
                            id: 'modification-approval',
                            title: 'GM อนุมัติแผน',
                            statusIds: [
                                MoldOrderStatus.MODIFICATION_APPROVAL
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'HardHatIcon',
                        },
                        {
                            id: 'pending-repair',
                            title: 'รอ Modify',
                            statusIds: [
                                MoldOrderStatus.PENDING_REPAIR
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'repair-in-progress',
                            title: 'กำลัง Modify',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS,
                                MoldOrderStatus.REPAIR_IN_PROGRESS,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-200 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-300',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างตรวจงาน',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pending-testing',
                            title: 'ออกใบทดลองพิมพ์',
                            statusIds: [
                                MoldOrderStatus.PENDING_TESTING
                            ],
                            colorCode: 'fuchsia',
                            color: 'bg-fuchsia-100 text-fuchsia-800',
                            textColor: 'text-fuchsia-800',
                            hoverColor: 'hover:bg-fuchsia-200',
                            countBg: 'bg-fuchsia-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'reporter-review',
                            title: 'SK ตรวจงาน',
                            statusIds: [
                                MoldOrderStatus.REPORTER_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'customer-review',
                            title: 'ลูกค้าตรวจรับ',
                            statusIds: [
                                MoldOrderStatus.CUSTOMER_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Drill',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                            textColor: 'text-white',
                            borderColor: 'border-amber-200',
                            shadow: 'shadow-lg shadow-amber-200/50',
                        },
                        colorCode: 'yellow',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MODIFY_ORDERS,
                },
                {
                    key: 'repair-v1',
                    group: 'repair',
                    moldOrderTypes: [
                        MoldOrderType.REPAIR,
                        MoldOrderType.MODIFY,
                    ],
                    filters: {
                        moldOrderTypeGroups: [
                            {
                                value: MoldOrderMainType.REPAIR,
                                label: 'ซ่อมแม่พิมพ์',
                                subTypes: [
                                    MoldOrderType.REPAIR,
                                ]
                            },
                            {
                                value: MoldOrderMainType.MODIFY,
                                label: 'Modify แม่พิมพ์',
                                subTypes: [
                                    MoldOrderType.MODIFY,
                                ]
                            }
                        ],
                    },
                    version: 1,
                    title: 'ซ่อม/Modify (เก่า)',
                    columns: [
                        {
                            id: 'reporter-fill-form',
                            title: 'กรอกข้อมูลปัญหา',
                            statusIds: [
                                MoldOrderStatus.REPORTER_FILL_FORM
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-300 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-200',
                            countBg: 'bg-gray-50',
                            icon: 'SquarePenIcon',
                        },
                        {
                            id: 'pending-acknowledge',
                            title: 'รอรับใบงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ACKNOWLEDGE
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-100/50',
                            icon: 'FileText',
                        },
                        {
                            id: 'assessment',
                            title: 'ประเมินเบื้องต้น',
                            statusIds: [
                                MoldOrderStatus.ASSESSMENT
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'HardHatIcon',
                        },
                        {
                            id: 'pending-preapproval',
                            title: 'อนุมัติแผนซ่อม/Modify',
                            statusIds: [
                                MoldOrderStatus.MARKETING_APPROVAL,
                                MoldOrderStatus.PLANNING_APPROVAL,
                                MoldOrderStatus.MODIFICATION_APPROVAL,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pe-assessment',
                            title: 'วิศวกรประเมิน',
                            statusIds: [
                                MoldOrderStatus.PE_ASSESSMENT_APPROVAL
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pending-repair',
                            title: 'รอซ่อม/Modify',
                            statusIds: [
                                MoldOrderStatus.PENDING_REPAIR
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'repair-in-progress',
                            title: 'กำลังซ่อม/Modify',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS,
                                MoldOrderStatus.REPAIR_IN_PROGRESS,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-200 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-300',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'reporter-review',
                            title: 'ผู้แจ้งปัญหาอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.REPORTER_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pe-result-approval',
                            title: 'วิศวกรอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.PE_RESULT_APPROVAL,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Wrench',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                            textColor: 'text-white',
                            borderColor: 'border-amber-200',
                            shadow: 'shadow-lg shadow-amber-200/50',
                        },
                        colorCode: 'yellow',
                    },
                    createNewOrderUrl: null
                },
                {
                    key: 'mold_acceptance',
                    group: 'mold_acceptance',
                    moldOrderTypes: [
                        MoldOrderType.MOLD_ACCEPTANCE,
                    ],
                    filters: {
                        moldOrderTypeGroups: [],
                    },
                    title: 'รับแม่พิมพ์',
                    columns: [
                        {
                            id: 'pending-arrival',
                            title: 'รอเข้าโรงงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ARRIVAL
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'TruckIcon',
                        },
                        {
                            id: 'detailed-inspection',
                            title: 'ตรวจสอบละเอียด',
                            statusIds: [
                                MoldOrderStatus.DETAILED_INSPECTION
                            ],
                            colorCode: 'amber',
                            color: 'bg-amber-100 text-amber-800',
                            textColor: 'text-amber-800',
                            hoverColor: 'hover:bg-amber-200',
                            countBg: 'bg-amber-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างตรวจสอบ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-200',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE,
                                MoldOrderStatus.END_REJECTED,
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'FileCheck',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'OutlinedMoldIcon',
                            source: 'custom',
                            props: { color: "#2563eb", size: 24, strokeWidth: 60, showHolders: false },
                            disabledProps: { color: "#9CA3AF", size: 24, strokeWidth: 60, showHolders: false },
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                            textColor: 'text-white',
                            borderColor: 'border-emerald-200',
                            shadow: 'shadow-lg shadow-emerald-200/50',
                        },
                        colorCode: 'green',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MOLD_ACCEPTANCE_ORDERS
                },
                {
                    key: 'mold_export',
                    group: 'mold_export',
                    moldOrderTypes: [
                        MoldOrderType.MOLD_EXPORT,
                    ],
                    filters: {
                        moldOrderTypeGroups: [],
                    },
                    title: 'ส่งออกแม่พิมพ์',
                    columns: [
                        {
                            id: 'pending-inspection',
                            title: 'รอตรวจสอบ',
                            statusIds: [
                                MoldOrderStatus.PENDING_INSPECTION
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'detailed-inspection',
                            title: 'ตรวจสอบแม่พิมพ์',
                            statusIds: [
                                MoldOrderStatus.DETAILED_INSPECTION
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'gm-approval',
                            title: 'GM อนุมัติ',
                            statusIds: [
                                MoldOrderStatus.GM_APPROVAL
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'Clock',
                        },
                        {
                            id: 'pending-export',
                            title: 'รอส่งออก',
                            statusIds: [
                                MoldOrderStatus.PENDING_EXPORT
                            ],
                            colorCode: 'indigo',
                            color: 'bg-indigo-100 text-indigo-800',
                            textColor: 'text-indigo-800',
                            hoverColor: 'hover:bg-indigo-200',
                            countBg: 'bg-indigo-50',
                            icon: 'Truck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Truck',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-red-500 to-red-600',
                            textColor: 'text-white',
                            borderColor: 'border-red-200',
                            shadow: 'shadow-lg shadow-red-200/50',
                        },
                        colorCode: 'red',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MOLD_EXPORT_ORDERS,
                },
            ],
            defaultBoardKey: 'maintenance',
        }
    },
    dashboard: {
        taskRow: {
            /** Field shown in the third column of TaskRow - uses field renderers */
            infoField: 'moldCode',
        },
        // Day shift A (เช้า) = 08:00–20:00, night shift B (ดึก) = the rest.
        shifts: {
            dayStartHour: 8,
            dayEndHour: 20,
        },
    },
    table: {
        moldOrdersColumns: {
            availableColumns: [
                'id',
                'mold',
                'moldCode',
                'moldName',
                'moldNumber',
                'productParts',
                'type',
                'status',
                'priority',
                'assignedTo',
                'assignedTechnician',
                'createdAt',
                'orderDetail',
                'operationDate',
                'shiftCompleted',
                'machineNumber',
                'actions'
            ],
            defaultVisibleColumns: [
                'id',
                'moldCode',
                'moldName',
                'type',
                'status',
                'priority',
                'assignedTo',
                'createdAt',
                'orderDetail',
                'actions'
            ],
            customLabels: {
                'id': 'เลขที่',
                'assignedTechnician': 'ผู้เช็คระดับ',
                'operationDate': 'วันที่ปฏิบัติงาน'
            }
        },
        moldOrdersInMoldPageColumns: {
            availableColumns: [
                'id',
                'mold',
                'moldCode',
                'moldName',
                'moldNumber',
                'productParts',
                'type',
                'status',
                'priority',
                'assignedTo',
                'assignedTechnician',
                'createdAt',
                'orderDetail',
                'operationDate',
                'shiftCompleted',
                'machineNumber',
                'actions'
            ],
            defaultVisibleColumns: [
                'id',
                'moldCode',
                'moldName',
                'type',
                'status',
                'createdAt',
                'orderDetail',
                'actions'
            ],
            customLabels: {
                'id': 'เลขที่',
                'assignedTechnician': 'ผู้เช็คระดับ',
                'operationDate': 'วันที่ปฏิบัติงาน'
            }
        },
        moldColumns: {
            availableColumns: [
                'sbiId',
                'moldCode',
                'moldName',
                'productParts',
                'customer',
                'moldNumber',
                'status',
                'revision',
                'moldType',
                'moldSource',
                'cavity',
                'makerName',
                'plate',
                'gateType',
                'delayGate',
                'hotRunner',
                'hotRunnerType',
                'hotRunnerBrand',
                'qtyZoneHr',
                'partMatGrade',
                'surfaceFinish',
                'remarks',
                'shotCount',
                'servicingAlertShotThreshold',
                'servicingMaxShotThreshold',
                'shotCountDisplay',
                'cycleShotCountDisplay',
                'physicalShotCountDisplay',
                'maxShotCount',
                'width',
                'height',
                'length',
                'weight',
                'machineSizeMin',
                'machineSizeMax',
                'locatedRingOd',
                'nozzleSr',
                'insertEngraving',
                'insertChangeType',
                'currentLocation',
                'storageLocation',
                'assetNoCustomer',
                'actions'
            ],
            defaultVisibleColumns: [
                'moldCode',
                'moldName',
                'customer',
                'status',
                'shotCount',
                'actions'
            ],
            customLabels: {
                'sbiId': 'รหัสแม่พิมพ์',
                'customer': 'ลูกค้า',
                'moldNumber': 'แม่พิมพ์ลูกที่',
                'status': 'สถานะ',
                'shotCount': '#Shot',
                'actions': 'Actions'
            }
        }
    },
    search: {
        moldSearchFields: {
            availableSearchFields: [
                {
                    id: 'all',
                    label: 'ทั้งหมด',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์/Part No.',
                    enabled: true
                },
                {
                    id: 'moldId',
                    label: 'รหัสแม่พิมพ์',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์',
                    enabled: true
                },
                {
                    id: 'moldCode',
                    label: 'Mold Code',
                    placeholder: 'พิมพ์ Mold Code',
                    enabled: true
                },
                {
                    id: 'moldName',
                    label: 'Mold Name',
                    placeholder: 'พิมพ์ Mold Name',
                    enabled: true
                },
                {
                    id: 'customer',
                    label: 'ลูกค้า',
                    placeholder: 'พิมพ์ชื่อลูกค้า',
                    enabled: true
                }
            ],
            defaultSearchField: 'moldId' // SK defaults to specific search rather than 'all'
        },
        moldOrderSearchFields: {
            availableSearchFields: [
                {
                    id: 'all',
                    label: 'ทั้งหมด',
                    placeholder: 'พิมพ์คำค้นหา',
                    enabled: true
                },
                {
                    id: 'orderId',
                    label: 'เลขที่',
                    placeholder: 'พิมพ์เลขที่ใบงาน',
                    enabled: true
                },
                {
                    id: 'moldId',
                    label: 'รหัสแม่พิมพ์',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์',
                    enabled: true
                },
                {
                    id: 'assignedTo',
                    label: 'ผู้รับผิดชอบ',
                    placeholder: 'พิมพ์ชื่อผู้รับผิดชอบ',
                    enabled: true
                }
            ],
            defaultSearchField: 'all'
        }
    },
    homepage: {
        workOrderCards: [
            {
                id: 'maintenance',
                title: 'ใบงานเช็คระดับ',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=maintenance`,
            },
            {
                id: 'repair',
                title: 'ใบงานซ่อม',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=repair`,
            },
            {
                id: 'modify',
                title: 'ใบงานModify',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=modify`,
            },
            {
                id: 'mold_acceptance',
                title: 'ใบงานรับเข้า',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=mold_acceptance`,
            },
            {
                id: 'mold_export',
                title: 'ใบงานส่งออก',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=mold_export`,
            },
        ],
        taskTabs: {
            type: 'defined',
            tabs: [
                {
                    id: 'maintenance',
                    label: 'เช็คระดับ',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderMainType.MAINTENANCE_LEVEL1,
                        MoldOrderMainType.MAINTENANCE_LEVEL2,
                    ],
                },
                {
                    id: 'repair',
                    label: 'ซ่อม',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.REPAIR,
                    ],
                },
                {
                    id: 'modify',
                    label: 'Modify',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MODIFY,
                    ],
                },
                {
                    id: 'mold_acceptance',
                    label: 'รับแม่พิมพ์',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MOLD_ACCEPTANCE,
                    ],
                },
                {
                    id: 'mold_export',
                    label: 'ส่งออก',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MOLD_EXPORT,
                    ],
                },
            ]
        }
    }
} as AppState;
